export class Onset {
  private static _values: Onset[] = [];
  private static _lookup: Map<number, Onset> = new Map();

  static fromId(id: number) {
    const instance = Onset._lookup.get(id);
    if (instance === undefined) {
      throw new Error('Not a valid Onset.id: ' + id);
    }
    return instance;
  }

  static values(): Onset[] {
    return [...Onset._values];
  }

  // ---

  public readonly id: number;
  public readonly label: string;

  constructor(id: number, label: string) {
    this.id = id;
    this.label = label;
    Onset._values.push(this);
    Onset._lookup.set(id, this);
  }

  toJson(): { id: number; name: string } {
    return { id: this.id, name: this.label };
  }

  toString(): string {
    return '<Onset: ' + this.id + ", label='" + this.label + "'>";
  }
}
